import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M768 768v192h-128v-192h-192v-128h192v-192h128v192h192v128h-192z m64-576H192v640h192v128H64V64h896v320h-128V192z\" fill=\"#ffffff\" p-id=\"79930\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol